import React from "react";
import { useSelector } from "react-redux";
import { StatusIndicator, Link, Alert } from "@amzn/awsui-components-react";
import { FIRST_PASS_PRO_PERM_LDAP } from "src/constants/AppConstants";

const FirstPassAccessDeniedComponent = (props) => {
  const isFirstPassProFullUser = useSelector((globalState) => globalState.auth.isFirstPassProFullUser)


  return (
    <>{
      isFirstPassProFullUser == null ? <StatusIndicator type="loading">
        Checking access, please wait..
      </StatusIndicator> : <Alert type='error'>Access is limited to authorized teams. Check eligible teams or request access <Link external href={FIRST_PASS_PRO_PERM_LDAP}>Here</Link> .</Alert>
    }</>
  );
};

export default FirstPassAccessDeniedComponent;
